import React from "react";
import Button from "@mui/material/Button";
import ResponsiveAppBar from "../../components/appbar";
import Footer from "../../components/footer";

export default function Internhilfe(){

    const mailsupport = () => {
        window.location = "mailto:it@muscholl.com"
    }

    return(
        <div>
            <ResponsiveAppBar/>
            <h1 className={"Hilfe-Head"}>Hilfe</h1>
            <Button variant={"contained"} onClick={mailsupport} sx={
                {backgroundColor: "black", "&:hover":{ backgroundColor: "#ba10d1"}, position: 'absolute', left: '50%', top: '85%',
                    transform: 'translate(-50%, -50%)'}
            }>An Tim wenden</Button>

            <Footer/>
        </div>
    )
}